export interface PickupPlace {
  senderName: string | null;
  senderCompany: string | null;
  street: string | null;
  postcode: string | null;
  city: string | null;
  countryCode: string | null;
}

export interface PickupList {
  downloadId: string;
  place: PickupPlace;
  carrierId: number;
  carrierIdentifier: string;
  orderCount: number;
  packageCount: number;
}

export interface PickupListsResponse {
  pickupLists: PickupList[];
}

export enum PickupListDateType {
  SHIP_DATE = 'SHIP_DATE',
  SUGGESTED_EXPEDITION = 'SUGGESTED_EXPEDITION',
}

export interface PickupListsRequest {
  dateType: PickupListDateType;
  from: string;
  to: string;
  marketplaceCode?: string;
}

export interface PickupListDownloadRequest extends PickupListsRequest {
  downloadId: string;
}
